import type { TimelineEventType } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";

export interface TimelineEventGroup {
  id: string;
  label: string;
  types: readonly TimelineEventType[];
}

export const timelineEventGroups: readonly TimelineEventGroup[] = [
  {
    id: "conversation_created",
    label: "Conversation created",
    types: ["conversation_created"],
  },
  {
    id: "conversation_status_changed",
    label: "Status changed",
    types: ["conversation_status_changed"],
  },
  {
    id: "conversation_priority_changed",
    label: "Priority changed",
    types: ["conversation_priority_changed"],
  },
  {
    id: "conversation_assigned",
    label: "Assignment changed",
    types: ["conversation_assigned"],
  },
  {
    id: "conversation_read",
    label: "Marked as read",
    types: ["conversation_read"],
  },
  {
    id: "message_activity",
    label: "Message activity",
    types: ["message_sent", "message_received"],
  },
  { id: "thread_created", label: "Thread created", types: ["thread_created"] },
  {
    id: "tag_activity",
    label: "Tag activity",
    types: ["tag_added", "tag_removed"],
  },
  { id: "rules_triggered", label: "Rule applied", types: ["rules_triggered"] },
];

export const allGroupIds: readonly string[] = timelineEventGroups.map(
  (g) => g.id,
);

const eventTypeToGroupId = new Map<TimelineEventType, string>(
  timelineEventGroups.flatMap((g) => g.types.map((t) => [t, g.id])),
);

export function getGroupIdForEventType(
  eventType: TimelineEventType,
): string | undefined {
  return eventTypeToGroupId.get(eventType);
}

export function isGroupId(value: string): boolean {
  return allGroupIds.includes(value);
}
